<template>
  <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.6055 5.71656L8.20513 1.43312L9.60018 1.67855e-06L16.5 6.71656L9.60018 13.4331L8.20513 12L12.6055 7.71656L-6.74604e-07 7.71656L-4.99757e-07 5.71656L12.6055 5.71656Z"
      fill="currentColor"
    />
  </svg>
</template>
